
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/experiment",
      function () {
        return require("private-next-pages/experiment.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/experiment"])
      });
    }
  